<template>
<div v-if="showBackdrop" class="backdrop" @mousedown="closeDrawers"></div>
</template>

<style lang="scss" scoped>
$opacity: 0.3;

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  -webkit-opacity: $opacity;
  -moz-opacity: $opacity;
  opacity: $opacity;

  -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s; /* Firefox < 16 */
  -ms-animation: fadein 0.5s; /* Internet Explorer */
  -o-animation: fadein 0.5s; /* Opera < 12.1 */
  animation: fadein 0.5s;
  z-index: 1;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: $opacity;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: $opacity;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: $opacity;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: $opacity;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: $opacity;
  }
}
</style>

<script>
import bus from '@/core/helpers/bus'

export default {
  name: 'OneBackdrop',
  data() {
    return {
      showBackdrop: false,
      drawer: 'none'
    }
  },
  methods: {
    show(val) {
      this.showBackdrop = val
      setTimeout(() => {
        if (val) {
          document.querySelector('html').classList.add('overflow-y-hidden')
        } else {
          document.querySelector('html').classList.remove('overflow-y-hidden')
        }
      })
    },
    closeDrawers() {
      bus.$emit('closeLeftDrawer')
      bus.$emit('closeRightDrawer')
    }
  },
  mounted() {
    bus.$on('openLeftDrawer', () => {
      if (this.drawer === 'left') {
        this.show(!this.showBackdrop)
      } else {
        this.show(true)
      }
      this.drawer = 'left'
    })
    bus.$on('openRightDrawer', () => {
      if (this.drawer === 'right') {
        this.show(!this.showBackdrop)
      } else {
        this.show(true)
      }
      this.drawer = 'right'
    })
    bus.$on('closeLeftDrawer', () => {
      this.show(false)
      this.drawer = 'none'
    })
    bus.$on('closeRightDrawer', () => {
      this.show(false)
      this.drawer = 'none'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/core/components/Backdrop.vue